import { render, staticRenderFns } from "./PanelGroup.vue?vue&type=template&id=af209ebe&scoped=true&"
import script from "./PanelGroup.vue?vue&type=script&lang=js&"
export * from "./PanelGroup.vue?vue&type=script&lang=js&"
import style0 from "./PanelGroup.vue?vue&type=style&index=0&id=af209ebe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af209ebe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/apple/Desktop/linebot-backend.hciot.com.tw/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('af209ebe')) {
      api.createRecord('af209ebe', component.options)
    } else {
      api.reload('af209ebe', component.options)
    }
    module.hot.accept("./PanelGroup.vue?vue&type=template&id=af209ebe&scoped=true&", function () {
      api.rerender('af209ebe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/reserve_system_dashboard/components/PanelGroup.vue"
export default component.exports